import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';
import IMAGES from '../../const/images';

import { Header } from '../../components/Onboarding/Header';
import { ResetForm } from '../../components/ResetPassword';

const { Title, Text } = Typography;

const ResetPasswordScreen = () => {
    const { t } = useTranslation('login');

    return (
        <div
            style={{ backgroundImage: `url(${IMAGES.login.spirals})` }}
            className="public-layout"
        >
            <div className="public-layout__container">
                <div className="public-layout__container--form">
                    <Space direction="vertical" size={28}>
                        <Header />
                        <Title level={2} style={{ color: '#6C8EEF', marginBottom: 0 }}>
                            { t('RESET_PASSWORD') }
                        </Title>
                        <Text>
                            { t('RESET_PASSWORD_HELP')}
                        </Text>
                        <Space direction="vertical" size={24}>
                            <ResetForm />
                            <div className="flex-row center-row-center">
                                <Space size={4}>
                                    <Text type="secondary">
                                        {t('DO_NOT_HAVE_AN_ACCOUNT')}
                                    </Text>
                                    <Link to="/signup" key="reset">
                                        {t('CREATE_AN_ACCOUNT')}
                                    </Link>
                                </Space>
                            </div>
                        </Space>
                    </Space>
                </div>
            </div>
        </div>
    );
};

export { ResetPasswordScreen };
